'use client';

import { useCallback, useRef, useState } from 'react';
import { toast } from 'sonner';
import { useIntegrationSetup } from './IntegrationSetupContext';

/** Notify the original catalog after a successful write, including after modal close.
 * The catalog owns project and dialog-generation guards for late completions.
 */
export function useIntegrationSetupFlow(scopeId?: string) {
  const setup = useIntegrationSetup();
  const [error, setError] = useState<string | null>(null);
  const reportError = useCallback((message: string) => {
    setError(message);
    toast.error(message);
  }, []);
  const clearError = useCallback(() => setError(null), []);
  const currentScope = useRef(scopeId);
  currentScope.current = scopeId;
  const onConfigured = useCallback(() => {
    if (currentScope.current === scopeId) setup.onConfigured?.();
  }, [scopeId, setup.onConfigured]);
  return { ...setup, onConfigured, error, reportError, clearError };
}
